module.exports = __webpack_public_path__ + "img/undefined.91a324da.svg";